const { PI } = Math

export const START_AT_TOP = (3 / 2) * PI

export const CLOCKWISE = 1

export const MAX_ARC_PROPORTION = 0.999
